export const modalsConstants = {
  SET_MODAL_VISIBLE: 'modals/SET_MODAL_VISIBLE',
  CLEAR_MODALS: 'modals/CLEAR_MODALS',
};
